import { PublicRoutes } from "@/constants/routes";
import type { FAQItem } from "@/pages/landingPage/components";
import { HUB_CRUMB, webApplicationSchema } from "../constants";

export const PATH = PublicRoutes.FERRAMENTA_GERADOR_CARNE;
// Sem o sufixo "| Fidexa": o titleTemplate de src/App.tsx acrescenta.
export const TITLE = "Gerador de Carnê de Crediário Grátis em PDF";
export const DESCRIPTION =
  "Gerador de carnê de crediário grátis: preencha loja, cliente e parcelas e imprima ou salve o carnê em PDF na hora, com chave Pix e sem precisar de cadastro.";

export const TRAIL = [HUB_CRUMB, { name: "Gerador de carnê", path: PATH }];

export const WEB_APPLICATION = webApplicationSchema({
  name: "Gerador de carnê de crediário",
  path: PATH,
  description: DESCRIPTION,
});

export const MAX_INSTALLMENTS = 36;

export const FAQ_ITEMS: FAQItem[] = [
  {
    question: "O gerador de carnê é gratuito?",
    answer:
      "Sim. O gerador é gratuito e não pede cadastro. Os dados da loja e do cliente ficam só no seu navegador: a Fidexa não guarda nada, e tudo some quando você fecha a página.",
  },
  {
    question: "Como salvar o carnê em PDF?",
    answer:
      'Clique em "Imprimir ou salvar em PDF" e, na janela de impressão, escolha "Salvar como PDF" no destino. O arquivo sai só com as folhas do carnê, prontas para mandar ao cliente pelo WhatsApp ou imprimir na loja.',
  },
  {
    question: "O carnê gerado tem código de barras de boleto?",
    answer:
      "Não. É um carnê de controle do crediário próprio: cada folha traz parcela, vencimento e valor, com canhoto para a loja e via para o cliente. O pagamento é feito na loja ou por Pix, na chave que você informar no carnê.",
  },
  {
    question: "O que não pode faltar num carnê de crediário?",
    answer:
      "Nome e contato da loja, nome do cliente, número da parcela sobre o total (por exemplo, 03/10), data de vencimento, valor e um espaço para registrar o recebimento. Com a referência da venda e a chave Pix, o cliente sabe o que está pagando e como pagar sem ir até a loja.",
  },
];
